import React, {useState} from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { CardActionArea } from '@mui/material';

function SmallDashboardCard(props) {
    const { title, content, onClick, loading = false, isRed = false } = props;

    const doNothing = () => {

    }

    let cardClass = isRed ? "card-content color-red" : "card-content";

    let cardContent = loading ?
        <div className={"row justify-content-center"}>
            <div className="dot-flashing"></div>
        </div>
        : <div className={cardClass}>{content}</div>;
    return (
        <div className="row no-gutters margin-bottom-20" onClick={onClick === null ? doNothing : onClick}>
            <div className="col">
                <Card elevation={4} className="height-100p">
                    <CardContent className="pad-10-0">
                        <h6 className="pad-left-15">{title}</h6>
                        {cardContent}
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}

export default SmallDashboardCard;